import { ApprovalLoadMoreRow } from '../types/time-tracking-approvals';

const LOAD_MORE_ROW_ID_PREFIX = 'load-more-';
const EMPTY_ENTRIES_ROW_ID_PREFIX = 'empty-entries-';

/** True if a row is a synthetic sentinel (checked before all other guards). */
export const isLoadMoreRow = (data: unknown): data is ApprovalLoadMoreRow =>
  typeof data === 'object' &&
  data !== null &&
  (data as Record<string, unknown>).isLoadMore === true;

/** True if a row is the synthetic "no entries" empty-state placeholder. */
export const isEmptyEntriesRow = (data: unknown): data is ApprovalLoadMoreRow =>
  isLoadMoreRow(data) && data.variant === 'empty';

/** Builds a load-more (spinner) sentinel for a section, keyed by the section's row id. */
export const createLoadMoreRow = (sectionId: string): ApprovalLoadMoreRow => ({
  id: `${LOAD_MORE_ROW_ID_PREFIX}${sectionId}`,
  isLoadMore: true,
  variant: 'spinner',
});

/** Builds an empty-state placeholder row for a section that loaded with zero entries. */
export const createEmptyEntriesRow = (sectionId: string): ApprovalLoadMoreRow => ({
  id: `${EMPTY_ENTRIES_ROW_ID_PREFIX}${sectionId}`,
  isLoadMore: true,
  variant: 'empty',
});
